import db_lib from 'xAppLib/libs/db_lib';
import API_service from 'xAppLib/providers/API_service'



const _EMBEDDED_FIELDS = ["Details", 'Role', 'Created', 'Last SignIn']

// ---- --------------------------------------------  --------------------------------------------
// ---- --------------------------------------------  --------------------------------------------

export default class admin_users_model_base extends db_lib {

	static get EMBEDDED_FIELDS() { return _EMBEDDED_FIELDS; }

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------
	static pharms_dd_field( phs ) {

		return {
							name: "pharm",
							label:'Pharmacy',
							type: "select",
							options: (() => {
									let pa = [];
									Object.keys(phs)
										.map( k =>
												pa.push({
														key: k,
														value: k,
														text:
															phs[k].name + "  ::  " +
															(phs[k].email||"NO EMAIL") + "  ::  " +
															phs[k].address
													})
											)
									return pa
								})()
								,
									// [
									// 	// { key: 'af', value: 'af', flag: 'af', text: 'Afghanistan' },
									// 	{ key: 'gn', value: 'General', text: 'General' },
									// 	{ key: 'er', value: 'Report an error', text: 'Report an error' },
									// 	{ key: 'us', value: 'Help with usage', text: 'Help with usage' },
									// 	{ key: 'ps', value: 'Partnership', text: 'Partnership' },
									// ],
							placeholder: "Select",
							// param_name: "t",
							req_label: "*",
							// valid_not_required: true,
						}

	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static async load_users_list( params = {}, ca ) {

		return await API_service.load_data(
									'UserAdmin/listAllUsers', 
									{type: 'all', ...params},
									r => ca && ca(r)
								) 
	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static async get_all_records( ca, filters = {}, load_data ) {

		return await API_service.load_data(
									'UserAdmin/listAllUsers', 
									{type: 'all', filters, load_data},
									r => ca && ca(r)
								) 

		// firebase_functions.call(
		// 							'listAllUsersCall',
		// 							{type: 'all'},
		// 							r => ca && ca(r)
		// 						)

	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static async add_new_user( d, ca ) {

		return await API_service.load_data(
									'UserAdmin/addNewUser', 
									d,
									r => ca && ca(r)
								) 

		// firebase_functions.call(
		// 							'addNewUserCall',
		// 							d,
		// 							r => ca && ca(r)
		// 						)

	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static async edit_user_claims( u, c, ca ) {

		return await API_service.load_data(
									'UserAdmin/editUserClaims', 
									{u, c},
									r => ca && ca(r)
								) 
	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static async edit_user_org( u, o, ca ) {

		return await API_service.load_data(
									'UserAdmin/editUserOrg', 
									{u, o},
									r => ca && ca(r)
								) 
	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static async edit_user_booking_types( u, value, ca ) {

		return await API_service.load_data(
									'UserAdmin/editUserBookingTypes', 
									{u, value},
									r => ca && ca(r)
								) 
	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static async archive_user( u, ca ) {

		return await API_service.load_data(
									'UserAdmin/archiveUser', 
									{u},
									r => ca && ca(r)
								) 
	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static async delete_factor( uid, factorUID, extend, ca ) {

		return await API_service.load_data(
									'UserAdmin/removeFactor', 
									{uid, factorUID, extend},
									r => ca && ca(r)
								) 
	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static async extend_grace( uid, ca ) {

		return await API_service.load_data(
									'UserAdmin/extend_grace', 
									{uid},
									r => ca && ca(r)
								) 
	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	// static edit_user_field( u, f, ca ) {

	// 	firebase_functions.call(
	// 								'editUserFieldCall',
	// 								{u, f},
	// 								r => ca && ca(r)
	// 							)

	// }

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static async get_user_byuid( u, ca ) {

		return await API_service.load_data(
									'UserAdmin/findUserUID', 
									{u},
									r => ca && ca(r)
								) 

		// firebase_functions.call(
		// 							'findUserCall',
		// 							{u},
		// 							r => ca && ca(r)
		// 						)

	}

	static async get_user_prof_by_uid(uid) {
		const res = await API_service.load_data(
			"UserAdmin/getUserProfile",
			{ uid },
		);
		return res;
	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static async send_user_password( u, password, ca ) {

		return await API_service.load_data(
									'UserAdmin/sendUserPassword', 
									{uid:u.uid,password},
									r => ca && ca(r)
								) 

		// firebase_functions.call(
		// 							'sendUserPasswordCall',
		// 							{uid:u.uid,password},
		// 							r => ca && ca(r)
		// 						)

	}

	// ---- --------------------------------------------  --------------------------------------------

	static async set_user_newname( u, newname, ca ) {

		return await API_service.load_data(
									'UserAdmin/setUserNewName', 
									{uid:u.uid, newname},
									r => ca && ca(r)
								) 

		// firebase_functions.call(
		// 							'setUserNewNameCall',
		// 							{uid:u.uid, newname},
		// 							r => ca && ca(r)
		// 						)

	}

	// ---- --------------------------------------------  --------------------------------------------

	static async set_user_newemail( u, newemail, ca ) {

		return await API_service.load_data(
									'UserAdmin/setUserNewEmail', 
									{uid: u.prof?.par || u.uid, newemail},
									r => ca && ca(r)
								) 

		// firebase_functions.call(
		// 							'setUserNewEmailCall',
		// 							{uid:u.uid, newemail},
		// 							r => ca && ca(r)
		// 						)

	}

	static async set_cred( u, cred, ca ) {

		return await API_service.load_data('UserAdmin/setUserCred', {uid: u.uid, cred}) 

	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	// ---- --------------------------------------------  --------------------------------------------

	static async upd_user_prof( params, ca ) {

		// console.log('upd_user_prof');

		return await API_service.load_data(
									'UserAdmin/updUserProf', 
									params,
									r => ca && ca(r)
								) 
	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static async send_message( uid, msg, type ) {
		return await API_service.load_data('UserAdmin/sendUserMessage', { uid, msg, type }) 
	}

	static async get_user_messages({ uid, page, limit }) {
		return await API_service.load_data('UserAdmin/getUserMessages', { uid, page, limit })
	}

	// ---- --------------------------------------------  --------------------------------------------
}
